// ColorMarkDetection.jsx

import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import { FaFilePdf, FaChevronRight,FaEnvelope } from 'react-icons/fa';
// import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';

import '../styles/ColorMarkDetection.css';
import colorImage from '../assets/colorSensor.png'; // Replace with actual image
import eseImage from '../assets/colorSensor.png';     // Replace with actual image

import ESE_Pdf from '../assets/Color_Mark_ESE-DWS50N AKUSENSE.pdf' 

export default function ColorMarkDetection() {
  const [activeTab, setActiveTab] = useState('products');
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);


  return (
    <div className="ColorMarkDetection-wrapper">
      <Header />

      <div className="hero-banner19">
        <div className="hero-banner19-content">
          <h1>COLOR MARK DETECTION</h1>
          <div className="sensor-breadcrumb">
            <a href="/">Home</a> <FaChevronRight /> <span>Color Mark Detection</span>
          </div>
        </div>
      </div>

      <section className="sensor-main-content">
        <div className="color-sensor-description-block">
          <img src={colorImage} alt="Color Sensor" />
          <div>
            <h2>Color / I-Mark Detection</h2>
            <ul>
              <li>Detection Method : Diffuse Reflection</li>
              <li>Detection Distance : 30mm - 500mm</li>
              <li>Response Time : Color mark mode: 0.5ms; color mode: 2ms</li>
              <li>Digital Screen : 4-digit digital tube display</li>
              <li>Ambient Temperature : -10°C~+55°C (working), -20°C~+70°C (storage)</li>
            </ul>
            <div className="sensor-buttons">
              <a href={ESE_Pdf}  target="_blank" rel="noopener noreferrer">
              <button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Full Catalog Download</button>
              </a>
          <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}><FaEnvelope /> Request a Quote</button>
          {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
      {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

            </div>
          </div>
        </div>

        <div className="sensor-tabs">
          <button className={activeTab === 'products' ? 'active' : ''} onClick={() => setActiveTab('products')}>
            Color Sensor Products
          </button>
          <button className={activeTab === 'specs' ? 'active' : ''} onClick={() => setActiveTab('specs')}>
            Technical Specifications
          </button>
        </div>

        <div className="sensor-tab-content">
          {activeTab === 'products' && (
            <div className="sensor-product-list">
              <div className="sensor-product-card">
                <img src={eseImage} alt="ESE Series" />
                <h4>ESE Series</h4>
                <ul>
                  <li>Light Source: White light LED, adjustable light spot, minimum light spot ¢3.6mm</li>
                  <li>Protection Degree: IP67</li>
                  <li>Output selection: LIGHT-ON/DARK-ON switchable</li>
                </ul>
              <a href={ESE_Pdf}  target="_blank" rel="noopener noreferrer">
                <button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button>
              </a>
              </div>
            </div>
          )}

          {activeTab === 'specs' && (
            <table className="specs-table">
              <tbody>
                <tr><td><strong>Sensing method</strong></td><td>Diffuse reflection</td></tr>
                <tr><td><strong>Sensing distance</strong></td><td>30mm - 500mm</td></tr>
                <tr><td><strong>Light source</strong></td><td>White light LED, adjustable light spot, minimum light spot 3.6mm</td></tr>
                <tr><td><strong>Light emitting element</strong></td><td>Red/Blue/Green Composite LED (light emission peak wavelength: 625nm/470nm/525nm)</td></tr>
                <tr><td><strong>Output</strong></td><td>NPN/PNP open-collector</td></tr>
                <tr><td><strong>Indicator</strong></td><td>Output indicator: Yellow</td></tr>
                <tr><td><strong>Response Time</strong></td><td>Mark mode: 0.5ms, color mode: 2ms</td></tr>
                <tr><td><strong>Switch type</strong></td><td>Lon/Don selectable</td></tr>
                <tr><td><strong>Digital display</strong></td><td>Four digits</td></tr>
                <tr><td><strong>Operating voltage</strong></td><td>150mA</td></tr>
                <tr><td><strong>Current Consumption</strong></td><td>&lt;10mA</td></tr>
                <tr><td><strong>Leakage Current</strong></td><td>&lt;0.01mA</td></tr>
                <tr><td><strong>Switch Mode</strong></td><td>2KHz</td></tr>
                <tr><td><strong>Repeatability</strong></td><td>&lt;1.0%(Sr)</td></tr>
                <tr><td><strong>Hysteresis</strong></td><td>&lt;15%(Sr)</td></tr>
                <tr><td><strong>Sensing Surface Material</strong></td><td>PBT</td></tr>
                <tr><td><strong>Ambient Temperature</strong></td><td>-10°C~+55°C (working), -20°C~+70°C (storage)</td></tr>
                <tr><td><strong>Circuit Protection</strong></td><td>Short-circuit protection</td></tr>
                <tr><td><strong>Protection Degree</strong></td><td>IP67</td></tr>
              </tbody>
            </table>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
